import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SizeChartModalPage } from './size-chart-modal.page';

const routes: Routes = [
  {
    path: '',
    component: SizeChartModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SizeChartModalPage]
})
export class SizeChartModalPageModule {}
